<template>
  <div class="knowedge-detail">
    <common-bg-plate>
      <detail-section title="隐私计算任务基本信息">
        <div class="basic-box basic-info">
          <div v-for="(ele, index) in showArr" :key="ele + index" class="item-line basic-info-line">
            <div class="item-label">{{ ele.label }}：</div>
            <div class="item-text">{{ infoObj[ele.value] }}</div>
          </div>
        </div>
      </detail-section>
      <div class="line"></div>
      <detail-section title="数据参与情况">
        <!-- 是否有任务参与方 -->
        <div v-show="hasJoin">
          <el-row>
            <el-col :span="18">
              <el-table :data="joinList">
                <el-table-column type="index" label="序号" width="80" align="center">
                </el-table-column>
                <el-table-column
                  prop="user"
                  label="操作用户"
                  align="left"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row['chainUser']['userName'] || $constants.EMPTY }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="org"
                  label="操作组织"
                  align="left"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row['chainUser']['orgName'] || $constants.EMPTY }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="org"
                  label="加密数据"
                  align="left"
                  min-width="200"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row['commitment'] || $constants.EMPTY }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="orgId"
                  label="提交时间"
                  align="left"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <span>{{
                      $utils.dateFormat('YYYY-mm-dd HH:MM', scope.row['createdTime'] * 1000) ||
                        $constants.EMPTY
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
        <div v-show="!hasJoin" class="no-person-box">
          <div class="no-person-tip">暂无参与方</div>
        </div>
        <!-- 判断本人是否参与任务，若没有，显示参与任务按钮 -->
        <div v-show="isJoin && infoObj.dataStatus !== 'cantJoin'" class="member-info">
          <div class="upload-data-box data-show">
            <div class="upload-title">提交零知识证明数据</div>
            <div class="upload-line">
              <div class="upload-label">随机因子：</div>
              <div class="upload-text">{{ randomFactor || '--' }}</div>
            </div>
            <div class="upload-line">
              <div class="upload-label">数据承诺：</div>
              <div class="upload-text">{{ joinedData.commitment || '--' }}</div>
            </div>
            <div class="upload-line">
              <div class="upload-label">数据证明：</div>
              <div class="upload-text">{{ joinedData.proof || '--' }}</div>
            </div>
            <div class="upload-line last-line">
              <div class="upload-label">提交时间：</div>
              <div class="upload-text">
                {{ joinedData.createdTime ? formatTime(joinedData.createdTime * 1000) : '--' }}
              </div>
            </div>
          </div>
        </div>
        <div class="member-info">
          <el-button
            v-show="!isJoin && !showOperate && infoObj.openStatus !== 'closed'"
            type="primary"
            class="join-btn"
            @click="joinTask()"
            >参与任务</el-button
          >
          <el-button
            v-show="infoObj.openStatus == 'canClose'"
            type="primary"
            class="chain-btn"
            @click="closeTask()"
            >关闭任务</el-button
          >
        </div>
        <!--参与任务-->
        <div v-show="showOperate" class="member-info">
          <div class="upload-data-box step-box-wrap">
            <div class="upload-title">提交零知识证明数据</div>
            <div class="upload-step-box">
              <upload-step ref="uploadStepRef" :step-type="'2'"></upload-step>
            </div>
            <div class="upload-line">
              <div class="upload-label">随机因子：</div>
              <div class="upload-text">{{ randomFactor || '--' }}</div>
            </div>
            <div class="upload-line">
              <div class="upload-label">原始数据：</div>
              <div v-show="step == 0" class="upload-text">
                <el-input v-model="uploadData.data" class="upload-input"></el-input>
              </div>
              <div v-show="step == 1" class="upload-text">
                {{ uploadData.data }}
              </div>
            </div>
            <div v-show="step == 1" class="upload-line">
              <div class="upload-label">数据承诺：</div>
              <div class="upload-text">
                {{ uploadData.commitData }}
              </div>
            </div>
            <div v-show="step == 1" class="upload-line">
              <div class="upload-label">数据证明：</div>
              <div class="upload-text">
                {{ uploadData.proveData }}
              </div>
            </div>
            <div class="upload-box-btn-wrap">
              <el-button v-show="step == 0" type="primary" @click="handleStep(1)"
                >生成数据承诺和证明</el-button
              >
              <el-button
                v-show="step == 1"
                type="primary"
                :disabled="uploadDisabled"
                class="chain-btn"
                @click="submitData()"
                >提交数据承诺</el-button
              >
              <el-button v-show="step == 1" type="primary" @click="handleStep(0)"
                >重新生成承诺</el-button
              >
            </div>
          </div>
        </div>
      </detail-section>
      <div
        v-show="infoObj.dataStatus == 'decrypted' || infoObj.dataStatus == 'toDecrypt'"
        class="line"
      ></div>
      <detail-section
        v-show="infoObj.dataStatus == 'decrypted' || infoObj.dataStatus == 'toDecrypt'"
        title="隐私计算结果"
      >
        <div class="basic-box">
          <div class="item-line result-btn-wrap">
            <el-button type="primary" @click="handleIncrypt()">解密计算结果</el-button>
          </div>
          <div class="item-line">
            <div class="item-label">计算结果：</div>
            <div class="item-text">
              {{ computingLoading ? computingLoadingText : computeResult }}
            </div>
          </div>
        </div>
      </detail-section>
    </common-bg-plate>
  </div>
</template>
<script>
import uploadStep from './components/uploadStep.vue'
export default {
  components: {
    uploadStep
  },
  data() {
    return {
      showArr: [
        { label: '数据名称', value: 'name' },
        { label: '创建时间', value: 'createdTime' },
        { label: '数据描述', value: 'description' },
        { label: '创建用户', value: 'userName' },
        { label: '创建机构', value: 'orgName' }
      ],
      resultArr: [{ label: '计算结果', value: 'result' }],
      infoObj: {},
      resultObj: {
        result: ''
      },
      hasJoin: false, // 是否有任务参与方 true有 false无
      isJoin: false, // 本人是否参与任务 true有 false无
      showOperate: false,
      uploadData: {
        data: '',
        commitData: '',
        proveData: ''
      },
      step: 0,
      joinList: [],
      randomFactor: '',
      joinedData: {},
      userInfo: {},
      computeResult: '--',
      computingLoading: false,
      computingLoadingText: '解密中...',
      uploadDisabled: false
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      let param = {
        chainId: this.$route.query.chainId,
        taskId: this.$route.query.taskId
      }
      this.$apis.privacy.getZeroTaskDetail(param).then(res => {
        this.infoObj = res.data
        this.infoObj.userName = res.data.createdChainUser.userName
        this.infoObj.orgName = res.data.createdChainUser.orgName
        this.infoObj.createdTime = this.formatTime(res.data.createdTime * 1000)
        // 判断随机因子显示
        this.userInfo = JSON.parse(sessionStorage.getItem('cbaas_privacy_chain_client'))
        let dataList = [res.data.data1, res.data.data2]
        if (res.data.dataStatus !== 'cantJoin') {
          if (res.data.dataStatus == 'tojoin') {
            let index = dataList.findIndex(ele => ele.commitment == '')
            if (index > -1) {
              this.randomFactor = dataList[index]['opening']
            }
          } else {
            // 获取自己的数据
            this.handleJoinData(res)
          }
        }
        this.handleJoinList(res.data)
        if (res.data.dataStatus == 'tojoin') {
          this.isJoin = false
        } else {
          this.isJoin = true
        }
      })
    },
    handleJoinData(res) {
      // 找到自己参与的数据,回显数据详情
      let senderOrgId = this.userInfo.orgId
      if (res.data.data1.chainUser.orgId == senderOrgId) {
        this.joinedData = res.data.data1
        this.randomFactor = res.data.data1.opening
      }
      if (res.data.data2.chainUser.orgId == senderOrgId) {
        this.joinedData = res.data.data2
        this.randomFactor = res.data.data2.opening
      }
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    },
    handleJoinList(info) {
      if (info.data1.chainUser.userName && info.data1.chainUser.orgId) {
        let index = this.joinList.findIndex(
          ele =>
            ele.chainUser.orgId == info.data1.chainUser.orgId &&
            ele.chainUser.userName == info.data1.chainUser.userName
        )
        if (index == -1) {
          this.joinList.push(info.data1)
        }
      }
      if (info.data2.chainUser.userName && info.data2.chainUser.orgId) {
        let index = this.joinList.findIndex(
          ele =>
            ele.chainUser.orgId == info.data2.chainUser.orgId &&
            ele.chainUser.userName == info.data2.chainUser.userName
        )
        if (index == -1) {
          this.joinList.push(info.data2)
        }
      }
      this.hasJoin = this.joinList.length > 0
    },
    joinTask() {
      this.showOperate = true
    },
    // 关闭任务
    closeTask() {
      this.$confirm('此操作将关闭该任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let param = {
            chainId: this.$route.query.chainId,
            taskId: this.$route.query.taskId
          }
          this.$apis.privacy.closeZeroTasks(param).then(res => {
            this.$message.success('任务关闭成功！')
            this.refresh()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消关闭任务'
          })
        })
    },
    handleStep(num) {
      if (num == 1) {
        if (this.uploadData.data == '') {
          this.$message.warning('请输入原始数据')
          return
        }
        this.step = num
        this.$apis.privacy
          .dataProve({ opening: this.randomFactor, value: Number(this.uploadData.data) })
          .then(res => {
            if (res.data) {
              this.uploadData.commitData = res.data.commitment
              this.uploadData.proveData = res.data.proof
              this.$refs.uploadStepRef.changeStep(this.step)
            }
          })
      } else {
        this.step = num
        this.uploadData.commitData = ''
        this.uploadData.proveData = ''
        this.$refs.uploadStepRef.changeStep(this.step)
      }
    },
    handleIncrypt() {
      let param = {
        chainId: this.$route.query.chainId,
        taskId: this.$route.query.taskId
      }
      this.computingLoading = true
      this.$apis.privacy
        .decryptCompare(param)
        .then(res => {
          if (res.data) {
            this.computeResult = res.data.result
          }
          this.computingLoading = false
        })
        .catch(err => {
          this.computingLoadingText = '解密计算结果失败'
        })
    },
    submitData() {
      if (this.uploadData.commitData == '') {
        this.$message.warning('数据承诺为空，请稍后')
        return
      }
      if (this.uploadData.proveData == '') {
        this.$message.warning('数据证明为空，请稍后')
        return
      }
      this.uploadDisabled = true
      let param = {
        chainId: this.$route.query.chainId,
        taskId: this.$route.query.taskId,
        commitment: this.uploadData.commitData,
        proof: this.uploadData.proveData,
        value: Number(this.uploadData.data),
        userName: this.userInfo.userName,
        orgName: this.userInfo.orgName
      }
      this.$apis.privacy
        .saveZeroData(param)
        .then(res => {
          this.$message.success('数据承诺提交成功！')
          this.showOperate = false
          this.refresh()
        })
        .catch(err => {
          this.uploadDisabled = false
        })
    },
    refresh() {
      this.getDetail()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'knowedge-detail',
  (
    --knowedge-detail-color: #ffffff,
    --knowedge-detail-line-color: rgba(51, 73, 110, 1),
    --knowedge-detail-content-bg-color: rgba(58, 69, 109, 1),
    --knowedge-detail-content-item-label-color: rgba(255, 255, 255, 0.6),
    --knowedge-detail-content-item-text-color: #fff,
    --knowedge-detail-content-no-person-text-color: rgba(255, 255, 255, 1),
    --knowedge-detail-content-upload-box-border-color: rgba(51, 73, 110, 1),
    --knowedge-detail-content-upload-box-label-color: #fff,
    --knowedge-detail-content-upload-box-text-color: rgba(255, 255, 255, 0.6),
    --knowedge-detail-content-upload-box-title-color: #fff,
    --knowedge-detail-content-upload-data-show-bg: #3a456d
  ),
  (
    --knowedge-detail-color: #192227,
    --knowedge-detail-line-color: rgba(235, 235, 235, 1),
    --knowedge-detail-content-bg-color: rgba(248, 248, 248, 1),
    --knowedge-detail-content-item-label-color: rgba(90, 105, 115, 1),
    --knowedge-detail-content-item-text-color: rgba(25, 34, 39, 1),
    --knowedge-detail-content-no-person-text-color: rgba(90, 105, 115, 1),
    --knowedge-detail-content-upload-box-border-color: rgba(235, 235, 235, 1),
    --knowedge-detail-content-upload-box-label-color: rgba(25, 34, 39, 1),
    --knowedge-detail-content-upload-box-text-color: rgba(90, 105, 115, 1),
    --knowedge-detail-content-upload-box-title-color: #192227,
    --knowedge-detail-content-upload-data-show-bg: #f8f8f8
  )
);
.knowedge-detail {
  @include adaptation(
    (
      --knowedge-detail-line-width: 1px,
      --knowedge-detail-content-padding: 20px 16px 10px 16px,
      --knowedge-detail-content-item-font-size: 14px,
      --knowedge-detail-content-item-margin-bottom: 10px,
      --knowedge-detail-content-item-label-width: 70px,
      --knowedge-detail-content-no-person-tip-margin-bottom: 24px,
      --knowedge-detail-content-upload-box-padding: 27px 50px,
      --knowedge-detail-content-upload-box-title-font-size: 16px,
      --knowedge-detail-content-upload-input-width: 400px,
      --knowedge-detail-content-result-btn-margin: 24px 0,
      --knowedge-detail-content-item-content-font: 12px
    )
  );
  --knowedge-detail-min-height: var(--base-main-router-body-avaliable-height);
  color: var(--knowedge-detail-color);
  .common-bg-plate {
    min-height: var(--knowedge-detail-min-height);
    .line {
      border-bottom: var(--knowedge-detail-line-width) solid var(--knowedge-detail-line-color);
    }
    .basic-info {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      .basic-info-line {
        width: 50%;
      }
    }
    .basic-box {
      background: var(--knowedge-detail-content-bg-color);
      padding: var(--knowedge-detail-content-padding);
      .item-line {
        display: flex;
        align-items: flex-start;
        font-size: var(--knowedge-detail-content-font);
        margin-bottom: var(--knowedge-detail-content-item-margin-bottom);
        .item-label {
          width: var(--knowedge-detail-content-item-label-width);
          flex-shrink: 0;
          color: var(--knowedge-detail-content-item-label-color);
        }
        .item-text {
          flex: 1;
          color: var(--knowedge-detail-content-item-text-color);
        }
      }
      .result-btn-wrap {
        margin: var(--homomorphic-detail-content-result-btn-margin);
      }
      .result-btn-wrap {
        margin: var(--knowedge-detail-content-result-btn-margin);
        margin-top: 0;
      }
    }
    .no-person-box {
      .no-person-tip {
        font-size: var(--knowedge-detail-content-item-font-size);
      }
    }
    .member-info {
      margin-top: var(--knowedge-detail-content-item-font-size);
    }
    .no-person-text {
      color: var(--knowedge-detail-content-no-person-text-color);
      margin-bottom: var(--knowedge-detail-content-item-margin-bottom);
    }
    .upload-data-box {
      border: var(--knowedge-detail-line-width) solid
        var(--knowedge-detail-content-upload-box-border-color);
      padding: var(--knowedge-detail-content-padding);
      .upload-step-box {
        margin-bottom: var(--knowedge-detail-content-no-person-tip-margin-bottom);
      }
      .upload-title {
        font-size: var(--knowedge-detail-content-upload-box-title-font-size);
        color: var(--knowedge-detail-content-upload-box-title-color);
        margin-bottom: var(--knowedge-detail-content-no-person-tip-margin-bottom);
      }
      .upload-line {
        display: flex;
        align-items: flex-start;
        font-size: var(--knowedge-detail-content-item-font-size);
        margin-bottom: var(--knowedge-detail-content-item-margin-bottom);
        .upload-label {
          flex-shrink: 0;
          width: var(--knowedge-detail-content-item-label-width);
          color: var(--knowedge-detail-content-upload-box-text-color);
          font-size: var(--knowedge-detail-content-item-content-font);
        }
        .upload-text {
          flex: 1;
          color: var(--knowedge-detail-content-upload-box-label-color);
          word-break: break-all;
          font-size: var(--knowedge-detail-content-item-content-font);
        }
        .upload-input {
          width: var(--knowedge-detail-content-upload-input-width);
        }
      }
      .upload-box-btn-wrap {
        margin-top: var(--knowedge-detail-content-no-person-tip-margin-bottom);
        margin-bottom: var(--knowedge-detail-content-item-margin-bottom);
      }
    }
    .step-box-wrap {
      padding-left: var(--knowedge-detail-content-no-person-tip-margin-bottom);
    }
    .data-show {
      background: var(--knowedge-detail-content-upload-data-show-bg);
      border: 0;
    }
    .chain-btn {
      margin-left: 0;
    }
    .join-btn {
      margin-right: var(--knowedge-detail-content-item-margin-bottom);
    }
  }
}
</style>
